import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export interface DetailsSectionState {
  showDetails: boolean;
  selectedItem: any | null;
  detailsTitle?: string;
  detailsMetric?: string;
  detailsSummary?: string;
  detailsCallbackId?: string;
}

const initialState: DetailsSectionState = {
  showDetails: false,
  selectedItem: null,
};

export const detailsSectionSlice = createSlice({
  name: "detailsSectionSlice",
  initialState,
  reducers: {
    setDetailsSectionShowDetails: (state, action: PayloadAction<boolean>) => {
      state.showDetails = action.payload;
    },
    setDetailsSectionSelectedItem: (
      state,
      action: PayloadAction<any | null>,
    ) => {
      state.selectedItem = action.payload;
    },
    setDetailsSectionDetailsTitle: (state, action: PayloadAction<string>) => {
      state.detailsTitle = action.payload;
    },
    setDetailsSectionDetailsMetric: (state, action: PayloadAction<string>) => {
      state.detailsMetric = action.payload;
    },
    setDetailsSectionDetailsSummary: (state, action: PayloadAction<string>) => {
      state.detailsSummary = action.payload;
    },
    setDetailsSectionDetailsCallbackId: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.detailsCallbackId = action.payload;
    },
  },
});

export const {
  setDetailsSectionShowDetails,
  setDetailsSectionSelectedItem,
  setDetailsSectionDetailsTitle,
  setDetailsSectionDetailsMetric,
  setDetailsSectionDetailsSummary,
  setDetailsSectionDetailsCallbackId,
} = detailsSectionSlice.actions;

export const showDetails = (state: RootState) =>
  state.detailsSection.showDetails;
export const selectedItem = (state: RootState) =>
  state.detailsSection.selectedItem;
export const detailsTitle = (state: RootState) =>
  state.detailsSection.detailsTitle;
export const detailsMetric = (state: RootState) =>
  state.detailsSection.detailsMetric;
export const detailsSummary = (state: RootState) =>
  state.detailsSection.detailsSummary;
export const detailsCallbackId = (state: RootState) =>
  state.detailsSection.detailsCallbackId;

export default detailsSectionSlice.reducer;
